import * as React from "react";

function SvgInfoOutline16Px(props) {
  return <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12zm0 2A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 5.006c0 .546.448.994.994.994C8.539 6 9 5.552 9 5.006A1.02 1.02 0 0 0 7.994 4C7.448 4 7 4.46 7 5.006zM8 7a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1z" fill="currentColor" /></svg>;
}

export default SvgInfoOutline16Px;